import request from '@/api/request.js'

// 新增
export function SystemMenuInsert(data) {
    return request({
        url: '/api/menu/systemmenuinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemMenuDelete(id) {
    return request({
        url: `/api/menu/systemmenudelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemMenuUpdate(id, data) {
    return request({
        url: `/api/menu/systemmenuupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemMenuGetById(id) {
    return request({
        url: `/api/menu/getsystemmenubyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemMenuGetList(params) {
    return request({
        url: '/api/menu/getsystemmenulist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemMenuGetPageList(params) {
    return request({
        url: '/api/menu/getsystemmenupagelist',
        method: 'get',
        params: params
    })
}